import React from 'react';
import { useTodoListCount } from './useTodoListCount';

const TodoListBadge: React.FC = () => {
  const { count } = useTodoListCount();

  if (count <= 0) return null;

  return <div className='todo-unread-badge'>{count}</div>;
};

export default TodoListBadge;
